import { render, staticRenderFns } from "./wareCard.vue?vue&type=template&id=559f5848&scoped=true&"
import script from "./wareCard.vue?vue&type=script&lang=js&"
export * from "./wareCard.vue?vue&type=script&lang=js&"
import style0 from "./wareCard.vue?vue&type=style&index=0&id=559f5848&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "559f5848",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SvgIcon: require('/app/components/svgIcon/svgIcon.vue').default})
